module.exports = __webpack_public_path__ + "img/pixing_xc10.4dba4526.jpg";